<div class="field-dialog">
  <mat-toolbar class="field-dialog__header" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="field-dialog__header__title" *ngIf="!isUpdate">
      {{ 'RECURRENCES.DIALOG.NEW_RECURRENCE' | translate }}
    </h2>

    <h2 class="field-dialog__header__title" *ngIf="isUpdate && !isViewMode">
      {{ 'RECURRENCES.DIALOG.EDIT_RECURRENCE' | translate }}
    </h2>

    <h2 class="field-dialog__header__title" *ngIf="isViewMode">
      {{ 'RECURRENCES.DIALOG.VIEW_RECURRENCE' | translate }}
    </h2>

    <button class="field-dialog__header__close" mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <mat-tab-group class="field-dialog__content">
    <mat-tab [label]="'RECURRENCES.DIALOG.TABS.GENERAL.TITLE' | translate">
      <disclaimer
        *ngIf="isViewMode"
        [message]="
          (recurrence && recurrence.company && recurrence.source === 'eyeofsauron'
            ? 'RECURRENCES.DIALOG.TABS.GENERAL.RECURRENCE_CREATED_BY_COMPANY'
            : 'RECURRENCES.PERMISSIONS.NO_EDIT'
          )
            | translate
              : {
                  companyName: recurrence.company && recurrence.company.name
                }
        "
      >
      </disclaimer>

      <tab-general [recurrenceForm]="recurrenceForm" [maintenanceTypes]="maintenanceTypes"></tab-general>
    </mat-tab>

    <mat-tab [disabled]="disableLinks">
      <ng-template mat-tab-label>
        <div class="dialog-create-maintenance__tab-label">
          <span>{{ 'MAINTENANCES.CREATE_DIALOG.TAB_LINKS.LABEL' | translate }}</span>
          <span class="dialog-create-maintenance__tab-label_new-circle"></span>
        </div>
      </ng-template>

      <tab-links [form]="recurrenceForm" [recurrence]="recurrence" [isViewMode]="isViewMode"></tab-links>
    </mat-tab>

    <mat-tab *ngIf="isUpdate" [label]="'RECURRENCES.DIALOG.TABS.OCCURRENCES.TITLE' | translate">
      <tab-occurrences></tab-occurrences>
    </mat-tab>

    <mat-tab *ngIf="isUpdate" [label]="'RECURRENCES.DIALOG.TABS.HISTORIC.TITLE' | translate">
      <tab-historic></tab-historic>
    </mat-tab>
  </mat-tab-group>

  <div
    *ngIf="recurrenceForm && !isViewMode"
    class="field-dialog__footer"
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <button
      class="field-background"
      mat-raised-button
      (click)="saveRecurrence()"
      [disabled]="!isFormValid || isLoading"
    >
      {{ 'RECURRENCES.DIALOG.SAVE' | translate }}
    </button>

    <div *ngIf="isUpdate">
      <button
        mat-icon-button
        (click)="copyRecurrence()"
        [matTooltip]="'RECURRENCES.DIALOG.COPY' | translate"
        [disabled]="!isFormValid || isLoading"
      >
        <mat-icon class="font-size-20 secondary-text">content_copy</mat-icon>
      </button>

      <button
        mat-icon-button
        (click)="openArchiveOrUnarchiveDialog()"
        *ngIf="!recurrence.archived"
        [matTooltip]="'RECURRENCES.DIALOG.ARCHIVE' | translate"
      >
        <mat-icon class="secondary-text">archive</mat-icon>
      </button>

      <button
        mat-icon-button
        (click)="openArchiveOrUnarchiveDialog()"
        *ngIf="recurrence.archived"
        [matTooltip]="'RECURRENCES.DIALOG.UNARCHIVE' | translate"
      >
        <mat-icon class="secondary-text">unarchive</mat-icon>
      </button>
    </div>
  </div>
</div>
